<template>
  <div class="content d-flex-right">
    <div class="header">
      <div style="margin: 5px 0">
        <div>
          <SelectCdjProjectHeader :items="['type_id', 'place_id','region_id','project_id']" @onHeader="onHeader">
            <el-select placeholder="账龄类型" clearable v-model="reginWhere.age" filterable size="mini">
              <el-option :value="1" label="当期"></el-option>
              <el-option :value="2" label="纯上一年"></el-option>
              <el-option :value="3" label="1年以上2年以内"></el-option>
              <el-option :value="4" label="2年以上"></el-option>
            </el-select>
            <el-select v-model="where.thrid_company_id" class="m-2" filterable placeholder="选择合作单位" clearable size="mini">
              <el-option
                v-for="item in thrid_company_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-date-picker
              style="width: 150px"
              v-model="where.start_time"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </SelectCdjProjectHeader>
        </div>
      </div>
    </div>

    <div class="body">
      <el-tabs type="border-card" v-model="card_index">
<!--        <el-tab-pane label="第三方申请" name="ThirdPartyLegalMainPlan">-->
<!--          <ThirdPartyLegalMainPlan v-if="card_index==='ThirdPartyLegalMainPlan'" :urge_type="3" />-->
<!--        </el-tab-pane>-->
        <el-tab-pane label="申请数据" name="ThirdpartyLayout">
          <!--          <ThirdPartyLegalPlan2 urge_type="ThirdPartyLegal" v-if="card_index==='ThirdPartyLegalPlan2'" />-->
<!--          <LegalHousePlanUnit v-if="card_index==='LegalHousePlanUnit'" :urge_type="3" @exportExcelNote="exportExcelNote"/>-->
          <ThirdpartyLayout v-if="card_index==='ThirdpartyLayout'" />
        </el-tab-pane>
        <el-tab-pane label="移交记录" name="ThirdPartyHandoverRecord">
          <ThirdPartyHandoverRecord v-if="card_index==='ThirdPartyHandoverRecord'" :urge_type="3" />
        </el-tab-pane>
        <el-tab-pane label="登记数据" name="ThirdPartyListLayout">
          <ThirdPartyListLayout v-if="card_index==='ThirdPartyListLayout'&&is_loading" />
        </el-tab-pane>
        <el-tab-pane label="近12月统计" name="12month">
          <ThirdPartyLegalStatisticsMonth v-if="card_index==='12month'" />
        </el-tab-pane>
        <el-tab-pane label="近30日统计" name="30day">
          <ThirdPartyLegalStatisticsDay v-if="card_index==='30day'" />
        </el-tab-pane>
<!--        <el-tab-pane label="当月完成率" name="dywcl">-->
<!--          <ThirdpartyCompletionRate v-if="card_index==='dywcl'" />-->
<!--        </el-tab-pane>-->
        <el-tab-pane label="月度完成率" name="ydwcl">
          <ThirdpartyCompletionRateYearMonth v-if="card_index==='ydwcl'" />
        </el-tab-pane>
        <el-tab-pane label="项目合作单位" name="ThirdPartyCompanyProject">
          <ThirdPartyCompanyProject v-if="card_index==='ThirdPartyCompanyProject'" :urge_type="3" />
        </el-tab-pane>
        <el-tab-pane label="合作单位管理" name="ThirdPartyCooperativeEnterprise">
          <ThirdPartyCooperativeEnterprise v-if="card_index==='ThirdPartyCooperativeEnterprise'" />
        </el-tab-pane>
<!--        <el-tab-pane label="当月账龄" name="AgingType">-->
<!--          <AgingType v-if="card_index==='AgingType'" types="3" />-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import LegalHousePlan from "./components/plan/LegalHousePlan";
import ThirdPartyListLayout from "./components/thirdparty/ThirdPartyListLayout";
import ThirdpartyCompletionRate from "./components/thirdparty/ThirdpartyCompletionRate";
import ThirdpartyCompletionRateYearMonth from "./components/thirdparty/ThirdpartyCompletionRateYearMonth";
import ThirdPartyCooperativeEnterprise from "./components/thirdparty/ThirdPartyCooperativeEnterprise";
import ThirdPartyCompanyProject from "./components/thirdparty/ThirdPartyCompanyProject";
import ThirdPartyLegalStatisticsMonth from "./components/thirdparty/ThirdPartyLegalStatisticsMonth";
import ThirdPartyLegalStatisticsDay from "./components/thirdparty/ThirdPartyLegalStatisticsDay";
import ThirdPartyHandoverRecord from "./components/thirdparty/ThirdPartyHandoverRecord";
import AgingType from "./components/common/AgingType";
import ThirdPartyLegalMainPlan from "./components/plan/ThirdPartyLegalMainPlan";
import ThirdPartyLegalPlan2 from "./components/plan/ThirdPartyLegalPlan2";
import LegalHousePlanUnit from "./components/plan/LegalHousePlanUnit";
import ButlerHttp from "./common/ButlerHttp";
import ThirdpartyLayout from "./components/thirdparty/ThirdpartyLayout";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";

export default {
  name: "ThirdPartyLegal",
  components: {
    SelectCdjProjectHeader,
    ThirdpartyLayout,
    LegalHousePlanUnit,
    ThirdPartyLegalPlan2,
    ThirdPartyLegalMainPlan,
    AgingType,
    ThirdPartyLegalStatisticsDay,
    ThirdPartyLegalStatisticsMonth,
    ThirdPartyCompanyProject,
    ThirdPartyCooperativeEnterprise,
    ThirdpartyCompletionRateYearMonth, ThirdpartyCompletionRate, ThirdPartyListLayout,ThirdPartyHandoverRecord},
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data(){
    return{
      is_loading:false,
      where: {
        text:"",
        is_authentication:"",
        thrid_company_id:"",
        start_time:moment(new Date()).format("YYYY-MM"),
        end_time:moment(new Date()).format("YYYY-MM"),
      },
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[],
        age:""
      },
      card_index:"ThirdPartyListLayout",
      thrid_company_list:[]
    }
  },
  activated() {
    const that=this;
    that.getThridCompanyList()
    if(that.$route.query.card_index){
      that.card_index=that.$route.query.card_index
    }
  },
  methods:{
    getThridCompanyList(){
      const that = this;
      ButlerHttp.post("ThirdPartyLegal/getCollectionThridCompanyList", {
        status: 1,
        page: 1,
        page_size: 300
      }, res => {
        if (res.code) {
          that.thrid_company_list = res.data.list;
        }
      });
    },
    exportExcelNote(){
      const that = this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("ThirdPartyLegal/exportExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";
.content{
  padding: 10px;
  margin-left: 10px;

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ThirdPartyLegal.vue